<template>
  <v-group
    :config="groupConfig"
    @click="onIconClick"
    @tap="onIconClick"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut" >

    <v-rect :config="buttonConfig" />
    <v-text v-if="buttonText" :config="buttonTextConfig" />

  </v-group>
</template>

<script>
export default {
  props: {
    x: {},
    y: {},
    buttonText: {
      default: null
    },
    height: { default: 35 },
    width: { default: 180 },
    theme: { default: 'red' },
  },
  computed: {
    gradientColorStops() {
      switch ( this.theme ) {
        case 'red':  return [ 0, '#f85032', 0.5, '#f16f5c', 0.51, '#f6290c', 0.71, '#f02f17', 1, '#e73827' ]
        case 'blue': return [ 0, '#3b679e', 0.5, '#2b88d9', 0.51, '#207cca', 1, '#7db9e8' ]
        default:     return [ 0, 'red' ]
      }
    },
    groupConfig() {
      return {
        x: this.x || 0,
        y: this.y || 0,
        offsetX: 0,
        offsetY: 0,
      };
    },
    buttonConfig() {
      return {
        stroke: 'black',
        strokeWidth: 1,
        width: this.width,
        height: this.height,
        cornerRadius: 5,
        fillLinearGradientStartPoint: { x: 0, y: 0 },
        fillLinearGradientEndPoint: { x: 0, y: this.height },
        fillLinearGradientColorStops: this.gradientColorStops,
      }
    },
    buttonTextConfig() {
      return {
        fill: 'white',
        width: this.width,
        height: this.height,
        align: 'center',
        verticalAlign: 'middle',
        fontSize: 16,
        fontStyle: 'bold',
        text: this.buttonText,
      }
    }
  },
  methods: {
    onIconClick(event) {
      this.$emit('click', event)
    },
    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
    },
    onMouseOut(event) {
      document.body.style.cursor = 'default';
    }
  }
}
</script>
